var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_423_3856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.19879 14.7649L5.36348 17.8835L2.31004 17.9482C1.39738 16.2556 0.879883 14.3192 0.879883 12.2613C0.879883 10.2715 1.36363 8.3951 2.22145 6.74275H2.22191L4.9402 7.24103L6.13129 9.94291C5.88192 10.6695 5.74645 11.4495 5.74645 12.2613C5.74645 13.1421 5.90629 13.9863 6.19879 14.7649Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6704 10.0198C24.8082 10.7454 24.8799 11.4954 24.8799 12.2614C24.8799 13.1206 24.7894 13.9587 24.6174 14.7668C24.0333 17.5174 22.5071 19.9198 20.3925 21.6195L20.3916 21.619L16.9679 21.4442L16.4832 18.4189C17.8861 17.5962 18.9825 16.3081 19.5605 14.7668H13.1438V10.0198H24.6704Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3916 21.6185L20.3921 21.619C18.3357 23.2723 15.7233 24.2614 12.8799 24.2614C8.31006 24.2614 4.33693 21.7071 2.31006 17.9482L6.19881 14.765C7.21225 17.4696 9.82131 19.3948 12.8799 19.3948C14.1947 19.3948 15.4262 19.0395 16.4832 18.4189L20.3916 21.6185Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5393 3.02417L16.6519 6.20651C15.5579 5.5226 14.2651 5.12792 12.8799 5.12792C9.75193 5.12792 7.09411 7.14167 6.13177 9.94292L2.22239 6.74276H2.22192C4.2188 2.89198 8.24208 0.261353 12.8799 0.261353C15.7913 0.261353 18.4613 1.29823 20.5393 3.02417Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_423_3856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.879883 0.261353)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.ab5ef9aa57a718a56f063aeb05af4cc8.svg";
export { ForwardRef as ReactComponent };